/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';


export interface NewsletterOptinsRequest {

    /**
     * True to opt in, false to opt out, omit to leave as-is
     */
    newsletter?: boolean;

    /**
     * True to opt in, false to opt out, omit to leave as-is
     */
    newsletter_weekly?: boolean;

    /**
     * True to opt in, false to opt out, omit to leave as-is
     */
    army?: boolean;

    /**
     * True to opt in, false to opt out, omit to leave as-is
     */
    shop?: boolean;

    /**
     * True to opt in, false to opt out, omit to leave as-is
     */
    news_and_alerts?: boolean;

}

@Model('NewsletterOptins')
export class ApiNewsletterOptins extends BaseModel implements NewsletterOptinsRequest {

    /**
     * True to opt in, false to opt out, omit to leave as-is
     */
    
    
    newsletter: boolean;

    /**
     * True to opt in, false to opt out, omit to leave as-is
     */
    
    
    newsletter_weekly: boolean;

    /**
     * True to opt in, false to opt out, omit to leave as-is
     */
    
    
    army: boolean;

    /**
     * True to opt in, false to opt out, omit to leave as-is
     */
    
    
    shop: boolean;

    /**
     * True to opt in, false to opt out, omit to leave as-is
     */
    
    
    news_and_alerts: boolean;

}
